const DEVICE_TYPE_LABELS: Record<string, string> = {
  primaryreader: 'Primary reader',
  auxiliaryreader: 'Auxiliary reader',
  premiumiodevice: 'Premium I/O device',
  ipcamera: 'IP camera',
  ip_camera: 'IP camera',
  bridge_cam: 'Bridge camera',
  smart_lock: 'Smart lock',
  audio_bridge: 'Audio bridge',
  door_position: 'Door-position sensor',
  ios: 'iOS',
  android: 'Android',
};

const PROVIDER_LABELS: Record<string, string> = {
  pdk: 'ProDataKey',
  brivo: 'Brivo',
  seam: 'Seam',
  bridge: 'Intrlock Bridge',
  schlage: 'Schlage',
  turing: 'Turing Vision',
  rtsp: 'RTSP',
  unifi_access: 'UniFi Access',
  unifi_protect: 'UniFi Protect',
};

const normalizedKey = (value: unknown): string => String(value ?? '').trim().toLowerCase();

/** Converts internal snake/camel/constant identifiers into user-facing text. */
export function formatInternalLabel(value: unknown, fallback = 'Not reported'): string {
  const raw = String(value ?? '').trim();
  if (!raw) return fallback;
  const spaced = raw
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  if (!spaced) return fallback;
  return spaced.charAt(0).toUpperCase() + spaced.slice(1).toLowerCase();
}

export function formatDeviceType(value: unknown, fallback = 'Device'): string {
  return DEVICE_TYPE_LABELS[normalizedKey(value)] || formatInternalLabel(value, fallback);
}

export function formatProviderLabel(value: unknown, fallback = 'Provider not reported'): string {
  return PROVIDER_LABELS[normalizedKey(value)] || formatInternalLabel(value, fallback);
}
